// import { IconAccountCircle } from '../Icons';
// import { IconAddCircle } from '../Icons';
import { IconHome, IconAccountBox, IconDeviceHub } from '../Icons';
// import { IconRemoveRedEye } from '../Icons';
// import Auth from './Auth';

export const acl = [
    { linkto: '/Dash', Icon: IconHome, label: 'Dashboard', allowedRole: [1] },
    { linkto: '/viewPeople',Icon: IconAccountBox, label: 'View People',allowedRole: [1]},
    { linkto: '/TreeView',Icon: IconDeviceHub, label: 'Tree View',allowedRole: [1]},
]

export const hasRight = route => {
    // const roles = getRolesOfRoute(route);
    // const userRole = parseInt(Auth.getUserRole(), 10);

    // if (isNaN(userRole) || roles === undefined) {
    //     return false;

    // } else if (!roles.length) { //for everyone
    //     return true;

    // } else if (roles.indexOf(userRole) !== -1) {
    //     return true;
    // }
    // return false;
    return true
}

// function getRolesOfRoute(route) {
//     const max = acl.length;
//     for (let i = 0; i < max; i++) {
//         const menu = acl[i];
//         if (menu.collapsible) {
//             //SEARCH IN SUBMENUS
//             const max2 = menu.menus.length;
//             for (let j = 0; j < max2; j++) {
//                 if (menu.menus[j].linkto === route) {
//                     return menu.allowedRole;
//                 }
//             }
//         } else if (menu.linkto === route) {
//             return menu.allowedRole;
//         }
//     }
// }
